import PropTypes from 'prop-types';
import { variants, th } from 'style/theme';
import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

const Link = styled(RouterLink)`
  ${variants('variant', {
    primary: css`
      color: ${th('colors.primaryLink.default')};

      :hover {
        color: ${th('colors.primaryLink.hover')};
      }
    `,
    secondary: css`
      color: ${th('colors.secondaryLink.default')};

      :hover {
        color: ${th('colors.secondaryLink.hover')};
      }
    `,
    tertiary: css`
      color: ${th('colors.tertiaryLink.default')};
      text-decoration: none;
    `,
    dark: css`
      color: ${th('colors.darkLink.default')};

      :hover {
        color: ${th('colors.darkLink.hover')};
      }
    `,
    light: css`
      color: ${th('colors.lightLink.default')};

      :hover {
        color: ${th('colors.lightLink.hover')};
      }
    `
  })}
`;

Link.propTypes = {
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string.isRequired]),
  variant: PropTypes.string
};

Link.defaultProps = {
  variant: 'primary'
};

export default Link;
